import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;

    position: absolute;
    top: 50%;
    left: 30px;
    transform: translateY(-50%);
    z-index: 1;

    @media (max-width: 1000px) {
        position: relative;
        top: unset;
        left: unset;
        transform: unset;

        flex-direction: row;
    }
`;

export const Step = styled.div`
    display: flex;
    gap: 15px;
    cursor: pointer;
`;

export const Progress = styled.div<{ $current: boolean }>`
    width: 5px;
    height: 36px;
    background-color: #232031;
    border-radius: 100px;
    position: relative;

    transition: height 0.5s ease;

    ${({ $current }) =>
        $current &&
        css`
            height: 80px;
        `}

    @media (max-width: 1000px) {
        width: 20px;
        height: 5px;
    }
`;

export const Bar = styled(motion.div)`
    width: 100%;
    height: 0%;
    background-color: #fff;
    border-radius: 100px;

    position: absolute;
    top: 0;
    left: 0;
    transition: height 0.5s ease;
    z-index: 1;

    @media (max-width: 1000px) {
        width: 0%;
        height: 100%;
    }
`;

export const Text = styled(motion.div)`
    padding-top: 5px;
    color: #fff;
    font-size: 14px;
    line-height: 15.4px;
    font-weight: 700;
    letter-spacing: 0em;
    text-shadow: 0 0 21px #000;
    max-width: 145px;

    @media (max-width: 1000px) {
        position: absolute;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        max-width: unset;
        width: 150px;
    }
`;
